import Button from "components/base/Button";
import { Select } from "components/base/Form";
import { useModals } from "ModalProvider";
import OdooCustomersView from "pages/retailer/retailers/OdooCustomersView";
import { useContext } from "react";
import { PlanContext } from "../PlanForm";

const INCFOBOrderView = () => {
  const { extraData, setExtraData } = useContext(PlanContext);

  const modal = useModals();

  function showCustomers() {
    modal.present({
      title: "Choose FOB Customer",
      children: (
        <OdooCustomersView
          instance="INC"
          useType="OS_FOB_CHOOSE_CUSTOMER"
          onSelect={(customer) => {
            let invoiceAddressId, deliveryAddressId;

            const invoiceAddresses = customer.child_ids.filter(
              (i) => i.type === "invoice",
            );
            const deliveryAddresses = customer.child_ids.filter(
              (i) => i.type === "delivery",
            );
            if (invoiceAddresses.length > 0) {
              invoiceAddressId = invoiceAddresses[0].id;
            } else {
              invoiceAddressId = customer.id;
            }
            if (deliveryAddresses.length > 0) {
              deliveryAddressId = deliveryAddresses[0].id;
            } else {
              deliveryAddressId = customer.id;
            }

            setExtraData({
              ...extraData,
              fobCustomer: customer,
              invoiceAddressId,
              deliveryAddressId,
            });
            modal.hide();
          }}
        />
      ),
    });
  }

  let invoiceAddressOptions = [];
  let deliveryAddressOptions = [];

  if (extraData.fobCustomer) {
    invoiceAddressOptions = [
      extraData.fobCustomer,
      ...extraData.fobCustomer.child_ids.filter((i) => i.type === "invoice"),
    ];
    deliveryAddressOptions = [
      extraData.fobCustomer,
      ...extraData.fobCustomer.child_ids.filter((i) => i.type === "delivery"),
    ];
  }

  return (
    <div className="place-content-stretch">
      <h5>INC FOB Sales Order Info</h5>

      <div className="mt-2 space-y-3">
        <div className="flex space-x-6">
          <div className="flex items-baseline space-x-3 ">
            <label>Warehouse: </label>
            <span>Dropship</span>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <label>FOB Customer: </label>
          {extraData.fobCustomer && <span>{extraData.fobCustomer.name}</span>}
          <Button onClick={showCustomers}>Choose Customer</Button>
        </div>

        {extraData.fobCustomer && (
          <>
            <div className="flex items-baseline space-x-3 w-full">
              <label className="whitespace-nowrap">Invoice Address: </label>
              <Select
                className="w-full"
                value={extraData.invoiceAddressId}
                onChange={(e) =>
                  setExtraData({
                    ...extraData,
                    invoiceAddressId: e.target.value,
                  })
                }
              >
                {invoiceAddressOptions.map((address) => (
                  <option key={address.id} value={address.id}>
                    {address.contact_address_inline}
                  </option>
                ))}
              </Select>
            </div>

            <div className="flex items-baseline space-x-3">
              <label className="whitespace-nowrap">Delivery Address: </label>
              <Select
                className="w-full"
                value={extraData.deliveryAddressId}
                onChange={(e) =>
                  setExtraData({
                    ...extraData,
                    deliveryAddressId: e.target.value,
                  })
                }
              >
                {deliveryAddressOptions.map((address) => (
                  <option key={address.id} value={address.id}>
                    {address.contact_address_inline}
                  </option>
                ))}
              </Select>
            </div>

            <div className="opacity-70 text-xs">
              If you need to create a new address, please do it in Odoo.
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default INCFOBOrderView;
